class AccountDrawer extends HTMLElement {
    constructor() {
        super(),
        this.accountDrawerInner = this.querySelector(".account-drawer__inner"),
        this.accountDrawerCloseIcon = this.querySelector(".account-drawer__close"),
      
     
       this.setHeaderCartIconAccessibility(),
        this.accountDrawerCloseIcon.addEventListener("click", this.close.bind(this)),
        
        this.addEventListener("click", (t=>{
          t.target.closest(".account-drawer__inner") !== this.accountDrawerInner && this.close()
        }
        ))
        window.cartUpsellDrawer = this;
       

    }
    setHeaderCartIconAccessibility() {
      document.querySelectorAll("#openAccountDwr").forEach((t=>{
          t.setAttribute("role", "button"),
          t.setAttribute("aria-haspopup", "dialog"),
          t.addEventListener("click", (e=>{
              this.open(t)
          }
          ))
      }))

      document.querySelectorAll("#redirc_acc_drw").forEach((t=>{
          t.setAttribute("role", "button"),
          t.setAttribute("aria-haspopup", "dialog"),
          t.addEventListener("click", (e=>{
              this.open(t)
          }
          ))
      }))

      document.querySelectorAll("#open_account_drwer").forEach((t=>{
          t.setAttribute("role", "button"),
          t.setAttribute("aria-haspopup", "dialog"),
          t.addEventListener("click", (e=>{
              this.open(t)
          }
          ))
      }))
  }
  
    open(t) {
        
        t && this.setActiveElement(t),
        this.classList.add("account-drawer--active"),
        requestAnimationFrame((()=>{
            this.style.setProperty("--m-bg-opacity", "0.5"),
            this.accountDrawerInner.style.setProperty("--translate-x", "0")
        }
        )),
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer)
    }
    close() {
        this.style.setProperty("--m-bg-opacity", "0"),
        this.accountDrawerInner.style.setProperty("--translate-x", "100%"),
        setTimeout((()=>{
            this.classList.remove("account-drawer--active")
        }
        ), 300)
    }
   
   
    getSectionDOM(t, e=".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e)
    }
    setActiveElement(t) {
        this.activeElement = t
    }
  }
  customElements.define("account-drawer", AccountDrawer);
